<template>
    <div class="out_sys_wrap">
          <div class="top">
           <el-button type="primary" size="medium" @click="releaseModuleadd()">新增发布应用</el-button>
        </div>	
        <div class="out_sys_box">
            <span class="out_sys_item"  v-for="item in dataList" :key="item.id" @click="releaseModuleadd(item.moduleCode)">
                <img :src="item.logoUrl" >
                <div class="sys_name">{{item.title}}</div>
                <i class="el-icon-delete" @click.stop="delMsgInit(item.moduleCode)"></i>
            </span>
        </div>
         <default-page Mes="暂无发布应用" v-if="dataList.length==0"></default-page>
    </div>
</template>

<script>
    import {getMsgInitList,delMsgInit} from '@/api/releaseModule'
    import DefaultPage from "@/components/DefaultPage";
    export default {
        name: "outSystem",
        data() {
            return {
                dataList:[]
            }
        },
        components: {DefaultPage},
        created() {
            this.getMsgInitList();
        },
        methods: {
             delMsgInit(moduleCode){
         this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delMsgInit(moduleCode).then(res => {
                      if (res.data.code === 200 && res.data.result) {
                 this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getMsgInitList();     
              } else {
                this.$message.error(res.data.msg);
              }
                       
                    }).catch();
                }).catch(() => {
                });
        
    },
            getMsgInitList() {
                getMsgInitList().then(data => {
                    this.dataList = data.data.data;
                })
            },
            releaseModuleadd(moduleCode){
                 this.$router.push({
                    path: "releaseModuleadd",
                    query:{
                        moduleCode:moduleCode
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';
    .top{
        padding-bottom: 10px;
        overflow: hidden;
    }
    .out_sys_wrap {
        @include scrollBar;
        padding:10px;
        .out_sys_box {
            @include clearfix;
            padding: 10px 0;

            .out_sys_item {
                display: block;
                float: left;
                margin-top: 18px;
                margin-left: 26px;
                overflow: hidden;                
                position: relative;
                cursor:pointer;
                i{
                    position: absolute;
                    right: 5px;
                    top: 5px;
                    color: red;
                }
                img {
                    display: block;
                    width: 80px;
                    height: 80px;
                }

                .sys_name {
                    height: 24px;
                    line-height: 24px;
                    margin-top: 5px;
                    text-align: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/releaseModule/releaseModuleindex.vue